"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var withTheme_1 = __importDefault(require("../utils/withTheme"));

var NoScript = function NoScript(_a, _b) {
  var image = _a.image;
  var theme = _b.theme;
  var style = {};

  if (image) {
    style.backgroundImage = "url(" + image + ")";
  }

  return React.createElement("noscript", null, withTheme_1["default"](theme, 'error')(React.createElement("div", {
    style: style
  }, withTheme_1["default"](theme, 'error__message')(React.createElement("div", null, "Du m\xE5ste aktivera JavaScript i webbl\xE4saren f\xF6r att kunna se denna video.")))));
};

NoScript.contextTypes = {
  theme: PropTypes.object
};
exports["default"] = NoScript;